<div class="cookie-banner" *ngIf="isBannerVisible()">
  <div class="cookie-content">
    <div class="title">
      <i class="ph-fill ph-cookie"></i>
      {{ 'doktar_app.cookie.title' | translate }}
    </div>
    <div class="description">
      {{ 'doktar_app.cookie.description' | translate }}
    </div>
  </div>
  <div class="actions">
    <dk-button [severity]="'secondary'" (click)="acceptEssentialsOnly()" data-testid="cookie-accept-essentials">
      {{ 'doktar_app.cookie.accept_essentials_button_label' | translate }}
    </dk-button>
    <dk-button [severity]="'primary'" [outlined]="true" (click)="acceptAll()" data-testid="cookie-accept-all">
      {{ 'doktar_app.cookie.accept_all_button_label' | translate }}
    </dk-button>
  </div>
</div>
